import { styled } from "@mui/material/styles";
import { ShowChart, Timeline } from "@mui/icons-material";
import { MenuTooltip } from "components/DataExplorationV2/MenuTooltip";
import { withTransientProps } from "core/utils/transientProps";

export interface ChartSubtypesProps {
  /** The type of chart selected*/
  chartType: ChartType;
  /** The subtype of chart selected*/
  chartSubtype: ChartSubtype;
  onChangeSubtype: (subtype: ChartSubtype) => void;
}

export const enum ChartType {
  LINE = "line"
  // SCATTER = "scatter"
}

export const enum ChartSubtype {
  LINE = "line-chart",
  LINE_WITH_MARKERS = "line-with-markers",
  SCATTER = "scatter"
}

/**
 * The icons to change the subtype of a chart (eg. line chart with points)
 */
export const ChartSubtypes = ({
  chartType,
  chartSubtype,
  onChangeSubtype
}: ChartSubtypesProps): JSX.Element | null => {
  switch (chartType) {
    case ChartType.LINE:
      return (
        <IconWrapper>
          <MenuTooltip title="Line Chart With Markers">
            <SubtypeButton
              aria-label="Line Chart With Markers"
              aria-pressed={chartSubtype === ChartSubtype.LINE_WITH_MARKERS}
              $selected={chartSubtype === ChartSubtype.LINE_WITH_MARKERS}
              onClick={() => onChangeSubtype(ChartSubtype.LINE_WITH_MARKERS)}
            >
              <Timeline />
            </SubtypeButton>
          </MenuTooltip>
          <MenuTooltip title="Line chart">
            <SubtypeButton
              aria-label="Line Chart"
              aria-pressed={chartSubtype === ChartSubtype.LINE}
              $selected={chartSubtype === ChartSubtype.LINE}
              onClick={() => onChangeSubtype(ChartSubtype.LINE)}
            >
              <ShowChart />
            </SubtypeButton>
          </MenuTooltip>
        </IconWrapper>
      );
    // case ChartType.SCATTER:
    //   return (
    //     <IconWrapper>
    //       <SubtypeButton
    //         aria-label="Scatter Chart"
    //         title="Scatter Chart"
    //         aria-pressed={chartSubtype === ChartSubtype.SCATTER}
    //         $selected={chartSubtype === ChartSubtype.SCATTER}
    //         onClick={() => onChangeSubtype(ChartSubtype.SCATTER)}
    //       >
    //         <ScatterPlot />
    //       </SubtypeButton>
    //     </IconWrapper>
    //   );
    default:
      return null;
  }
};

const SubtypeButton = styled("button", withTransientProps)<{
  $selected: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 35px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  margin-right: 9px;
  cursor: pointer;
  border: none;

  background-color: ${props => (props.$selected ? "#19173f" : "unset")};
  color: ${props => (props.$selected ? "white" : "unset")};

  :hover {
    color: white;
    background-color: #19173f;
  }
`;

const IconWrapper = styled("div")`
  display: flex;
  margin-top: 10px;
`;
